module.exports = __webpack_public_path__ + "img/cmd.10e8e4da.svg";